import React, { useCallback, useMemo } from 'react';
import Accordion from '../utils/Accordion/Accordion';
import {
  AccordionItemContent,
  AccordionItemFooter,
  Avatar,
  EarningsByMonthContainer,
  FooterText,
  FooterTextContainer,
  ItemCard,
  ItemContentContainer,
  LeftContent,
  LeftContentEmpty,
  RightContent,
} from './AgencyInfluencerEarningsByMonth.styles';
import { useSelector } from 'react-redux';
import { selectAgencyActionsPending, selectInfluencerEarningsByMonth } from '../../store/slices/agency/slice';
import { format, parse } from 'date-fns';
import { Text14Regular, Text18Bold } from '../utils/Text/Text.styles';
import Spinner from '../Spinner/Spinner';
import { formatPrice } from '../../utils/util';
import { AGENCY_INFLUENCERS } from '../App/routes';
import { useNavigate } from 'react-router-dom';

const AgencyInfluencerEarningsByMonth = () => {
  const navigate = useNavigate();
  const influencerEarningsByMonth = useSelector(selectInfluencerEarningsByMonth);
  const { fetchMonthlyInfluencersEarnings: fetchMonthlyInfluencersEarningsPending } =
    useSelector(selectAgencyActionsPending);

  const renderAccordionItemContent = useCallback(
    (data, totalEarningsNet, totalEarningsGross) => {
      return (
        <AccordionItemContent>
          <ItemContentContainer>
            {data.map((item, index) => {
              return (
                <ItemCard key={index} onClick={() => navigate(`/${AGENCY_INFLUENCERS}/${item.influencer.id}`)}>
                  <LeftContent>
                    <Avatar src={item.influencer.profilePhoto} />
                    <Text14Regular>{item.influencer.name}</Text14Regular>
                  </LeftContent>
                  <RightContent>
                    <FooterTextContainer>
                      <FooterText>Total Net: </FooterText>
                      <Text14Regular>${formatPrice(item.earnings.net)}</Text14Regular>
                    </FooterTextContainer>
                    <FooterTextContainer>
                      <FooterText>Total Gross: </FooterText>
                      <Text18Bold>${formatPrice(item.earnings.gross)}</Text18Bold>
                    </FooterTextContainer>
                  </RightContent>
                </ItemCard>
              );
            })}
          </ItemContentContainer>
          <AccordionItemFooter>
            <LeftContentEmpty />
            <FooterTextContainer>
              <FooterText>Total Net: </FooterText>
              <Text14Regular>${formatPrice(totalEarningsNet)}</Text14Regular>
            </FooterTextContainer>
            <FooterTextContainer>
              <FooterText>Total Gross: </FooterText>
              <Text18Bold>${formatPrice(totalEarningsGross)}</Text18Bold>
            </FooterTextContainer>
          </AccordionItemFooter>
        </AccordionItemContent>
      );
    },
    [navigate],
  );

  const data = useMemo(() => {
    if (influencerEarningsByMonth) {
      return Object.entries(influencerEarningsByMonth).map(([key, value]) => {
        const parsedDate = parse(key, 'yyyy-MM', new Date());
        const monthName = format(parsedDate, 'MMMM');
        const totalEarningsNet = value.reduce((acc, curr) => acc + curr.earnings.net, 0);
        const totalEarningsGross = value.reduce((acc, curr) => acc + curr.earnings.gross, 0);

        return {
          title: monthName,
          value: (
            <AccordionItemFooter>
              <FooterTextContainer>
                <FooterText>Total Net: </FooterText>
                <Text14Regular>${formatPrice(totalEarningsNet)}</Text14Regular>
              </FooterTextContainer>
              <FooterTextContainer>
                <FooterText>Total Gross: </FooterText>
                <Text18Bold>${formatPrice(totalEarningsGross)}</Text18Bold>
              </FooterTextContainer>
            </AccordionItemFooter>
          ),
          content: renderAccordionItemContent(value, totalEarningsNet, totalEarningsGross),
        };
      });
    }

    return [];
  }, [influencerEarningsByMonth, renderAccordionItemContent]);

  return (
    <EarningsByMonthContainer>
      {fetchMonthlyInfluencersEarningsPending ? <Spinner width={150} height={150} /> : <Accordion items={data} />}
    </EarningsByMonthContainer>
  );
};

export default AgencyInfluencerEarningsByMonth;
